import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import PageTemplate from '../components/Common/PageTemplate';
import SiteSearch from '../components/Common/SiteSearch';

const TXT = {
  tr: {
    title: 'Arama',
    subtitle: 'Haber, duyuru, sayfa ve kişi arayın',
    placeholder: 'Haber, duyuru, sayfa, kişi ara…',
    hint: 'Aramak istediğiniz kelimeyi yazın, sonuçlar anında görünsün.',
  },
  en: {
    title: 'Search',
    subtitle: 'Search news, announcements, pages and people',
    placeholder: 'Search news, announcements, pages, people…',
    hint: 'Type what you are looking for; results appear instantly.',
  },
};

const SearchPage = () => {
  const { i18n } = useTranslation();
  const L = TXT[(i18n.language || '').startsWith('en') ? 'en' : 'tr'];
  // Menüdeki arama kutusundan gelen kelime (/arama?q=...)
  const [params] = useSearchParams();
  const q = params.get('q') || '';
  return (
    <PageTemplate title={L.title} subtitle={L.subtitle}>
      <div className="max-w-2xl mx-auto py-4">
        <SiteSearch
          key={q}
          placeholder={L.placeholder}
          initialQuery={q}
          autoFocus
        />
        <p className="text-center text-sm text-gray-400 mt-6">
          {L.hint}
        </p>
      </div>
    </PageTemplate>
  );
};

export default SearchPage;
